import { Checkbox } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from '../translations/DeadlinesTable.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'deadlines-period-checkbox'
);
addTranslations(translations);

export interface DeadlinesPeriodCheckboxProps {
  onChange: (e: CheckboxChangeEvent) => void;
  showPastYear: boolean;
}

export const DeadlinesPeriodCheckbox: FC<DeadlinesPeriodCheckboxProps> = (
  props
) => {
  const { onChange, showPastYear } = props;
  const { t } = useTranslation();

  return (
    <CheckboxWrapper>
      <Checkbox id="show-past-year" checked={showPastYear} onChange={onChange}>
        {t('checkbox.show-past-year')}
      </Checkbox>
    </CheckboxWrapper>
  );
};

const CheckboxWrapper = styled.div`
  margin-right: auto;
`;
